var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUtilities0(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_10_1",
    "data-name": "Component 10 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 75.642,
    height: 93.414,
    viewBox: "0 0 75.642 93.414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_93",
    "data-name": "Rectangle 93",
    width: 75.642,
    height: 93.414,
    fill: "none",
    stroke: "#e0e1e5",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_93-2",
    "data-name": "Rectangle 93",
    width: 75.642,
    height: 93.414,
    fill: "none",
    stroke: "#707070",
    strokeWidth: 2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M11.958,51.268v0a2.98,2.98,0,0,0,5.958,0v0a2.98,2.98,0,0,0-5.958,0Z",
    transform: "translate(7.679 31.049)",
    fill: "none",
    stroke: "#e0e1e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M43.44,18.416A20.808,20.808,0,0,0,33.932,1.009c0,2.013,0,8.492,0,13.648L28.2,23.193l-12.313,0-5.73-8.538V1.009A20.8,20.8,0,0,0,.65,18.416c0,7.436,7.084,13.965,13.059,17.675L10.59,80.35A11.331,11.331,0,0,0,22.044,91.556,11.333,11.333,0,0,0,33.5,80.35L30.378,36.093C36.353,32.378,43.439,25.852,43.44,18.416Z",
    transform: "translate(0.417 0.648)",
    fill: "none",
    stroke: "#e0e1e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M51.336,38.777a5.536,5.536,0,0,1,3.547-4.853V25.659H30.664v8.265a5.535,5.535,0,0,1,3.545,4.853,5.535,5.535,0,0,1-3.545,4.853V66.2c0,5.339,5.421,9.666,12.109,9.666S54.883,71.542,54.883,66.2V43.629A5.536,5.536,0,0,1,51.336,38.777Z",
    transform: "translate(19.692 16.478)",
    fill: "none",
    stroke: "#e0e1e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_54",
    "data-name": "Line 54",
    y1: 30.781,
    transform: "translate(62.465 11.356)",
    fill: "none",
    stroke: "#e0e1e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M42.117.65H37.3l-1.859,4.4L37.3,10.938h4.82l1.859-5.886Z",
    transform: "translate(22.758 0.417)",
    fill: "none",
    stroke: "#e0e1e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_55",
    "data-name": "Line 55",
    y2: 18.688,
    transform: "translate(62.465 63.628)",
    fill: "none",
    stroke: "#e0e1e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41-2",
    "data-name": "Group 41",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_225-2",
    "data-name": "Path 225",
    d: "M11.958,51.268v0a2.98,2.98,0,0,0,5.958,0v0a2.98,2.98,0,0,0-5.958,0Z",
    transform: "translate(7.679 31.049)",
    fill: "none",
    stroke: "#d1914c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226-2",
    "data-name": "Path 226",
    d: "M43.44,18.416A20.808,20.808,0,0,0,33.932,1.009c0,2.013,0,8.492,0,13.648L28.2,23.193l-12.313,0-5.73-8.538V1.009A20.8,20.8,0,0,0,.65,18.416c0,7.436,7.084,13.965,13.059,17.675L10.59,80.35A11.331,11.331,0,0,0,22.044,91.556,11.333,11.333,0,0,0,33.5,80.35L30.378,36.093C36.353,32.378,43.439,25.852,43.44,18.416Z",
    transform: "translate(0.417 0.648)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227-2",
    "data-name": "Path 227",
    d: "M51.336,38.777a5.536,5.536,0,0,1,3.547-4.853V25.659H30.664v8.265a5.535,5.535,0,0,1,3.545,4.853,5.535,5.535,0,0,1-3.545,4.853V66.2c0,5.339,5.421,9.666,12.109,9.666S54.883,71.542,54.883,66.2V43.629A5.536,5.536,0,0,1,51.336,38.777Z",
    transform: "translate(19.692 16.478)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_54-2",
    "data-name": "Line 54",
    y1: 30.781,
    transform: "translate(62.465 11.356)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228-2",
    "data-name": "Path 228",
    d: "M42.117.65H37.3l-1.859,4.4L37.3,10.938h4.82l1.859-5.886Z",
    transform: "translate(22.758 0.417)",
    fill: "none",
    stroke: "#d1914c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_55-2",
    "data-name": "Line 55",
    y2: 18.688,
    transform: "translate(62.465 63.628)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtilities0);
export default __webpack_public_path__ + "static/media/utilities0.f2d81c6c60c7bd8edab3c2861100f7f1.svg";
export { ForwardRef as ReactComponent };